import React, { useContext} from 'react';
import ReactDOM from 'react-dom';

// context
import ListPageContext from '@/context/ListPageContext';
import {ListContext} from '@/context/ListContext';

// components
import ContentList from  '@/components/page/Content/ContentList/ContentList';



const ContentListPortal = () =>  {
    const targetContainer = document.getElementById('react-list-portal');
    const {setAppGuid, setAppId, setListId, listId, setOrgPermission, setListContentPermission, setListExistsInMultiplePlaces, setIsCombinedFeedEnabled} = useContext(ListContext)

    let defaultSort = undefined

    // Dont load if container doesnt exist
    if (targetContainer === null){
        return null;
    }

    else {
        setAppGuid(targetContainer?.getAttribute?.('data-app-guid'));
        setAppId(targetContainer?.getAttribute?.('data-app-id'));
        setOrgPermission(targetContainer?.getAttribute?.('data-orgpermission'));
        setListContentPermission(targetContainer?.getAttribute?.('data-contentpermission'));
        setListExistsInMultiplePlaces(targetContainer?.getAttribute?.('data-contentexistsinmultiple'));
        setIsCombinedFeedEnabled(targetContainer?.getAttribute?.('data-combinedfeedenabled')?.toLocaleLowerCase() === 'true')

        if(!listId || listId ==='0') {
            setListId(targetContainer?.getAttribute?.('data-menu-id'))
        };
        defaultSort = targetContainer?.getAttribute?.('data-default-sort-type')
    }

    return ReactDOM.createPortal(
        <ListPageContext defaultSort={defaultSort}>
            <ContentList />
        </ListPageContext> , targetContainer
    );
  
}

export default ContentListPortal;